<template>
  <component
    :is="nodeName"
    :disabled="disabled"
    :required="required"
    :label="label"
    :hint="hint"
    :hide-details="hideDetails"
    :value="value"
    :type="type.inputType"
    :type-config="type"
    :prefix="prefix"
    :suffix="suffix"
    :rules="rules"
    :items="items"
    :item-text="itemText"
    :rows="rows"
    :item-value="itemValue"
    :prepend-icon="prependIcon"
    :return-object="returnObject"
    :allowed-dates="allowedDates"
    :outlined="true"
    :readonly="readonly"
    :min="min"
    :max="max"
    @input="onInput"
    @blur="onBlur"
    @change="onChange"
  >
    <template
      v-if="isSlider"
      v-slot:append
    >
      <span
        class="pt-1 no-warp text-center"
        :style="type.sliderCallback?'width:60px':'width:20px'"
      >{{ sliderCallback(value1) }}</span>
    </template>
  </component>
</template>
<script>
import { VRadio, VCheckbox, VSelect, VSwitch, VTextarea, VTextField, VAutocomplete, VSlider } from 'vuetify/lib'
import DatePicker from './DatePicker'
import TimePicker from './TimePicker'

export default {
  name: 'UniversalInput',
  components: {
    VRadio,
    VSwitch,
    VCheckbox,
    VTextField,
    VTextarea,
    VSelect,
    DatePicker,
    TimePicker,
    VAutocomplete,
    VSlider,
  },
  props: {
    value: {},
    config: {
      type: Object,
      default: () => ({
        // name: 'mock',
        // label: 'mock label 1',
        // type: { 'name': 'text' }
      }),
    },

    // disabledControl: {
    //   type: Boolean,
    //   default: false
    // }
  },
  data() {
    return {
      defaultType: {
        name: 'text',
      },
      nodeNames: {
        radio: 'v-radio',
        switch: 'v-switch',
        checkbox: 'v-checkbox',
        text: 'v-text-field',
        textarea: 'v-textarea',
        datepicker: 'date-picker',
        timepicker: 'time-picker',
        select: 'v-select',
        file: 'v-file-input',
        autocomplete: 'v-autocomplete',
        slider: 'v-slider',
      },

      value1: null,
      value2: null,

      defaultDateFormat: 'yyyy/MM/dd',
      defaultTimeFormat: 'HH:mm:ss',
      defaultDateTimeSeparator: ' ',

      // disabled: false
    }
  },
  computed: {
    readonly() {
      if (this.config) {
        return this.config.readonly
      }

      return false
    },
    disabled() {
      if (this.config) {
        return this.config.disabled
      }

      return false
    },
    label() {
      if (this.config.label) {
        // console.log('this.config.label', this.config.label)
        if (this.config.label.toLowerCase().startsWith('message.')) {
          return this.$t(this.config.label)
        }

        return this.config.label
      }

      return ''
    },
    hint() {
      if (this.config.hint) {
        if (this.config.hint.toLowerCase().startsWith('message.')) {
          return this.$t(this.config.hint)
        }

        return this.config.hint
      }

      return ''
    },
    hideDetails() {
      if (this.type.hideDetails) {
        return this.type.hideDetails
      }

      return 'auto'
    },
    returnObject() {
      return this.type.returnObject || false
    },
    allowedDates() {
      return this.type.allowedDates || null
    },
    rows() {
      return this.type.rows || 5
    },

    // + this.$i18n.locale
    switchLocal() {
      return this.type.switchLocal || false
    },
    storeName() {
      return this.type.storeName || ''
    },
    min() {
      return this.type.min || 0
    },
    max() {
      return this.type.max || 100
    },
    items() {
      return this.type.items || this.$store.getters[this.storeName] || []
    },
    itemText() {
      let itemText = this.type.itemText || 'label'
      if (typeof itemText === 'string' && this.switchLocal) {
        itemText += this.$i18n.locale
      }

      // console.log('itemText', itemText)
      return itemText
    },
    itemValue() {
      return this.type.itemValue || 'id'
    },
    required() {
      return this.type.required || false
    },
    rules() {
      return this.type.rules || []
    },
    prefix() {
      return this.type.prefix || ''
    },
    suffix() {
      return this.type.suffix || ''
    },
    prependIcon() {
      return this.type.prependIcon || ''
    },
    options() {
      return this.type.options || []
    },
    nodeName() {
      return this.nodeNames[this.typeName]
    },
    dateTimeSeparator() {
      return this.type.dateTimeSeparator || this.defaultDateTimeSeparator
    },
    isSlider() {
      return this.typeName === 'slider'
    },
    isText() {
      return this.typeName === 'text'
    },
    isTextarea() {
      return this.typeName === 'textarea'
    },
    isSelect() {
      return this.typeName === 'select'
    },
    isDate() {
      return this.typeName === 'date'
    },
    isDateTime() {
      return this.typeName === 'datetime'
    },
    isTime() {
      return this.typeName === 'time'
    },
    isSwitch() {
      return this.typeName === 'switch'
    },
    isCheckbox() {
      return this.typeName === 'checkbox'
    },
    isRadio() {
      return this.typeName === 'radio'
    },
    isTextInput() {
      return this.isText || this.isTextarea
    },
    isInDateTime() {
      return this.isDate || this.isTime || this.isDateTime
    },
    dateOrTimeColSpan() {
      return this.isDateTime ? 11 : 24
    },
    typeName() {
      if (this.type) {
        if (this.type.name) {
          return this.type.name
        }

        return this.defaultType.name
      }

      return null
    },
    type() {
      return this.config.type || this.defaultType
    },
    returnValue() {
      return this.value1
    },
  },
  watch: {
    value(newvalue, oldvalue) {
      // console.log('newvalue', newvalue)
      this.updateValue(newvalue)
      this.update()
    },
  },
  created() {
    if (this.isCheckbox) {
      this.value1 = []
    }
  },
  mounted() {
    if (typeof this.config.defaultValue !== 'undefined') {
      console.log('this.label,defaultValue', this.label, this.config.defaultValue)
      this.updateValue(this.config.defaultValue)
    } else {
      this.updateValue(this.value)
    }
    this.update()
  },
  methods: {
    sliderCallback(value) {
      if (this.type.sliderCallback) {
        return this.type.sliderCallback(value)
      }

      return value
    },
    onChange(value) {
      console.log(`${this.config.label} onChange`, value)
      if (value) {
        this.updateValue(value)
      } else if (this.isText) {
        console.log('update to empty string')
        this.updateValue('')
      } else {
        this.updateValue(false)
      }
      this.update()
    },
    onBlur(e) {
      // console.log(`${this.config.label} onBlur`, e.target.value)
      if (this.isText) {
        this.$emit('blur')
        this.updateValue(e.target.value)
        this.update()
      }
    },
    onInput(value) {
      // console.log(`${this.config.label} onInput`, value)
      this.updateValue(value)
      this.update()
    },
    updateValue(newvalue) {
      // console.log(`${this.config.label} updateValue`, newvalue)
      if (this.type.inputType && this.type.inputType === 'number') {
        this.value1 = parseFloat(newvalue)

        // console.log(`${this.config.label} this.value1`, this.value1)
      } else {
        this.value1 = newvalue
      }
    },
    update() {
      this.$emit('input', this.returnValue)
      this.$emit('update')
    },
  },
}
</script>

<style scoped>
.no-warp{
  white-space: nowrap;
}
.slider-label{
  width: 60px;
}
</style>
